import React, { useRef, useState } from 'react'
import { useLoading } from '../../../context/LoadingContext';
import { useTranslation } from 'react-i18next';
import { CustomAdvancedMenuList, CustomDialog } from '../../../components/StyledComponents';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, ControlpanelSuccess3thButton, GrayIconButton } from '../../../components/StyledButton';
import CloseIcon from '@mui/icons-material/Close';
import CustomInput from '../../../components/CustomInput';
import { useConnectWS, useGetDeviceDetails, useReadCard } from '../../../hooks/useCheckid';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CustomSelect from '../../../components/CustomSelect';
import { useGetGeneralPolicyCountry } from '../../../hooks/useGeneralService';
import { initialSelectedPhoneCountry } from '../../../assets/data/common';
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import CustomDatePicker from '../../../components/CustomDatePicker';
import { useAuth } from '../../../context/AuthContext';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { format } from 'date-fns';
import AddIcon from '@mui/icons-material/Add';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
} from "@mui/material";
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import Webcam from "react-webcam";
import avatar_2 from "../../../assets/images/logo/avatar-default-logo.png";
import AddFileIcon16pxSvg from '../../../assets/images/icons/AddFileIcon16pxSvg';
import ImportDataDialog from './ImportDataDialog';
import EditIcon16pxSvgNew from '../../../assets/images/icons/EditIcon16pxSvgNew';
import { addVisitorUser, updateVisitorUser } from '../../../axios/Visitor/VisitorApi';
import { SpinnerRing } from '../../../components/CustomSpinner';
import ImportIcon16pxSvg from '../../../assets/images/icons/ImportIcon16pxSvg';

const EditVisitorUserDialog = ({ dataInfo, onClose, refreshData, handleRefreshData, refresh }) => {
    const [show, hide] = useLoading();
    const { t } = useTranslation();
    const [readingCard, setReadingCard] = useState(false);
    const [isMissingSoftware, setIsMissingSoftware] = useState(false);
    const getDevice = useGetDeviceDetails();
    const connectWS = useConnectWS();
    const readCard = useReadCard();
    const language = useSelector((state) => state.languageR.language);
    const [isReadCard, setIsReadCard] = useState(false);
    const [dataReadcard, setDataReadcard] = useState(null);
    const skipBlurRef = useRef(false);
    const [onBlurEvent, setonBlurEvent] = useState(false);
    const { data: countries } = useGetGeneralPolicyCountry();
    const [selectedPhoneCountry, setSelectedPhoneCountry] = useState(
        initialSelectedPhoneCountry
    );
    const { genaralSettingDateFormat } = useAuth();
    const [openAdvanced, setOpenAdvanced] = useState(false);

    const [openCamera, setOpenCamera] = useState(false);
    const [openFile, setOpenFile] = useState(false);
    const webcamRef = useRef(null);

    const capture = () => {
        const imageSrc = webcamRef.current.getScreenshot();

        setFormData((prev) => ({
            ...prev,
            faceImage: imageSrc,
        }));

        setOpenFile(false);
    };

    const anchorRefAdvanced = useRef(null);
    const handleQuickFilterChange = () => {
    };
    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };
    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    const initialFormData = {
        fullName: dataInfo?.fullName || '',
        personalID: dataInfo?.citizenIdentificationNumber || '',
        email: dataInfo?.email || '',
        phone: dataInfo?.mobile || '',
        faceImage: dataInfo?.profileImageUrl || '',
        langId: localStorage.getItem("i18nextLngId")
    };

    const [formData, setFormData] = useState(initialFormData);

    const [validationMessages, setValidationMessages] = useState({
        fullName: "",
        personalID: "",
        email: "",
        phone: "",
    });

    const handleDataChange = (name, newData) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: newData,
        }));
    };

    const handleReadCard = (cardId) => {
        try {
            show();
            setReadingCard(true);
            let deviceName = false;

            connectWS.mutate(
                {},
                {
                    onSuccess: (data) => {
                        setIsMissingSoftware(false);
                        hide(); // ẩn loading của connectWS
                        show(); // bật lại loading cho getDevice + readCard

                        getDevice.mutate(
                            { lang: language },
                            {
                                onSuccess: (dataReadcard) => {
                                    if (dataReadcard.deviceSN === "54822502250122") {
                                        deviceName = true;
                                    }
                                },
                                onError: (error) => {
                                    hide(); // **luôn dừng loading**
                                    setReadingCard(false); // dừng trạng thái reading
                                    toast.error(error.message || error);
                                },
                            }
                        );

                        readCard.mutate(
                            {
                                lang: language,
                                code: cardId.slice(-6),
                                deviceName: deviceName,
                            },
                            {
                                onSuccess: (dataReadcard) => {
                                    hide();
                                    setReadingCard(false);
                                    handleReadCardSuccess(dataReadcard);

                                    if (
                                        dataReadcard.optionalDetails.personalNumber !==
                                        formData.personalID
                                    ) {
                                        return setValidationMessages((prev) => ({
                                            ...prev,
                                            personalID: "common.content-014",
                                        }));
                                    }

                                    // if (dataReadcard.optionalDetails) {
                                    //     const { fullName } = dataReadcard.optionalDetails;

                                    //     // 👉 chỉ set fullName + image vào form
                                    //     setFormData((prev) => ({
                                    //         ...prev,
                                    //         fullName: fullName || "",
                                    //         faceImage: formatBase64Image(dataReadcard.image) || ""
                                    //     }));

                                    //     // 👉 vẫn giữ toast nếu bạn cần
                                    //     toast.success(t("common.content-013"));
                                    // }
                                },
                                onError: (error) => {
                                    hide(); // **luôn dừng loading**
                                    setReadingCard(false);
                                    if (error.error === 1102) {
                                        toast.error(t("common.CAN"));
                                    } else {
                                        toast.error(error.message || t("common.content-029"));
                                    }
                                },
                            }
                        );
                    },
                    onError: (error) => {
                        hide(); // **luôn dừng loading**
                        setReadingCard(false);
                        setIsMissingSoftware(true);
                        toast.error(t("common.content-028"));
                    },
                }
            );
        } catch (error) {
            hide(); // **luôn dừng loading**
            setReadingCard(false);
            toast.error(t("common.content-029"));
        }
    };

    const handleReadCardSuccess = (data) => {
        setDataReadcard(data);
        setIsReadCard(true);

        const formattedImage = formatBase64Image(data.image);

        setFormData((prev) => ({
            ...prev,
            faceImage: formattedImage,
            fullName: data.optionalDetails?.fullName || ""
        }));
    };

    const handleCloseDialog = () => {
        setFormData(initialFormData);
        onClose();
    };

    const updateFormDataAndValidate = (name, value) => {
        if (name === 'departmentPrefix') {
            // Giới hạn 2 ký tự + uppercase
            const trimmedValue = value.toUpperCase().slice(0, 2);

            setFormData((prevData) => ({
                ...prevData,
                [name]: trimmedValue,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleBlur = () => {
        if (skipBlurRef.current) {
            skipBlurRef.current = false;
            return;
        }

        const id = formData.personalID.trim();

        if (!/^\d{12}$/.test(id)) {
            setValidationMessages((prev) => ({
                ...prev,
                personalID: "common.content-009", // sai định dạng
            }));
        } else {
            setValidationMessages((prev) => ({
                ...prev,
                personalID: "",
            }));
            setonBlurEvent(true);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        updateFormDataAndValidate(name, value);

        if (name === "phone") {
            const phone = value.trim();

            if (!phone) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            } else if (!/^\d{9,13}$/.test(phone)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "common.content-024", // bạn tự define i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            }
        }

        if (name === "email") {
            const email = value.trim();

            if (!email) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "validation.email-invalid-format", // key i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            }
        }
    };

    const handleSubmit = async () => {
        try {
            setReadingCard(true);
            if (
                !formData.fullName ||
                !formData.personalID ||
                !formData.email ||
                !formData.phone
            ) {
                toast.error(t("common.fill-required"));
                return;
            }

            // 👉 remove prefix base64
            const cleanBase64 = formData.faceImage
                ? formData.faceImage.replace(/^data:image\/\w+;base64,/, "")
                : "";

            const payload = {
                ...formData,
                faceImage: cleanBase64,
                mobile: formData.phone,
                id: dataInfo.id,
                citizenIdentificationNumber: formData.personalID
            };

            const response = await updateVisitorUser(payload);

            // ===== SUCCESS =====
            if (
                response?.data?.responseCode === 0
            ) {

                toast.success(t("common.update-participant-successfully"));
                setFormData(initialFormData);
                onClose();
                handleRefreshData?.();
                setReadingCard(false);

            } else {

                toast.error(
                    response?.data?.data?.message ||
                    t("common.something-went-wrong")
                );
                setReadingCard(false);
            }
        } catch (error) {

            console.error(error);

            toast.error(
                error?.response?.data?.message ||
                t("common.something-went-wrong") ||
                "Something went wrong"
            );
            setReadingCard(false);
        }
    };

    const generateDateOptions = (start, end) => {
        const result = [];

        const startDate = new Date(start);
        const endDate = new Date(end);

        let current = new Date(startDate);

        while (current <= endDate) {
            result.push({
                label: format(current, genaralSettingDateFormat),
                value: format(current, "yyyy-MM-dd"),
            });

            current.setDate(current.getDate() + 1);
        }

        return result;
    };

    const fileInputRef = useRef(null);

    const handleOpenFile = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData((prev) => ({
                ...prev,
                faceImage: reader.result, // base64
            }));
        };
        reader.readAsDataURL(file);
    };

    const handleOpenCamera = async () => {
        try {
            // check camera permission + device
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });

            // stop ngay để tránh giữ camera
            stream.getTracks().forEach(track => track.stop());

            setOpenFile(true);
        } catch (error) {
            toast.error(t("common.no-camera") || "Thiết bị không có camera hoặc bị từ chối quyền");
        }
    };

    const formatBase64Image = (base64) => {
        if (!base64) return "";

        if (base64.startsWith("data:image")) return base64;

        // detect loại ảnh (optional nâng cao)
        const isPng = base64.startsWith("iVBOR"); // PNG signature
        const type = isPng ? "image/png" : "image/jpeg";

        return `data:${type};base64,${base64}`;
    };

    return (
        <>
            <CustomDialog maxWidth={'md'} open onClose={handleCloseDialog} keepMounted>
                {readingCard && (
                    <div className="absolute inset-0 z-[100] bg-white/60 flex items-center justify-center">
                        <div className="flex flex-col items-center gap-2">
                            <SpinnerRing loading={readingCard} size={50} color="#3B82F6" />
                        </div>
                    </div>
                )}
                <DialogTitle>
                    <div className='flex justify-between'>
                        <div className='flex items-center gap-4'>

                            <p className='text-xl font-semibold '>{t('common.update-participant')}</p>
                        </div>
                        <GrayIconButton onClick={handleCloseDialog}>
                            <CloseIcon />
                        </GrayIconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className='space-y-3 mt-4'>
                        <div className="w-full">
                            <div className="relative flex flex-col items-center">

                                {/* TOP LEFT BROWSER */}
                                {!formData.faceImage && (
                                    <div className="w-full flex justify-start mb-4">
                                        <div className='flex flex-col gap-2'>
                                            <p className='text-[#1F2937]'>
                                                {t('common.profilepicture')}
                                                <span className="text-red-500">*</span>
                                            </p>

                                            <p className='text-[#9CA3AF]'>
                                                {t('common.uploaddes')}
                                            </p>

                                            <ControlpanelSuccess3thButton
                                                onClick={() => setOpenFile(true)}
                                                className="flex items-center gap-2 px-4 h-full text-[#FCFCFC] hover:bg-[#00308C] max-w-[120px]"
                                            >
                                                <AddFileIcon16pxSvg color='#0057FF' />
                                                {t("common.browser")}
                                            </ControlpanelSuccess3thButton>
                                        </div>
                                    </div>
                                )}

                                {/* CENTER IMAGE */}
                                {formData.faceImage && (
                                    <div className="relative">
                                        <div className="flex items-center justify-center overflow-hidden border border-gray-200 p-[5px] rounded-[4px] bg-white">
                                            <img
                                                src={
                                                    formData?.faceImage
                                                        ? formData.faceImage.startsWith("data:image")
                                                            ? formData.faceImage
                                                            : `data:image/png;base64,${formData.faceImage}`
                                                        : avatar_2
                                                }
                                                alt="preview"

                                                className="w-[168px] h-[170px] object-cover rounded-[4px]"
                                            />
                                        </div>

                                        {/* FLOATING EDIT BUTTON */}
                                        <button
                                            ref={anchorRefAdvanced}
                                            onClick={() => setOpenFile(true)}
                                            className="
                        absolute
                        bottom-0
                        right-0
                        w-10
                        h-10
                        rounded-xl
                        bg-[#0057FF]
                        hover:bg-[#00308C]
                        flex
                        items-center
                        justify-center
                        shadow-lg
                        transition
                    "
                                        >
                                            <EditIcon16pxSvgNew />
                                        </button>
                                    </div>
                                )}

                                <input
                                    type="file"
                                    accept="image/*"
                                    capture="environment"
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                    hidden
                                />
                            </div>
                        </div>

                        <div>
                            <label>{t('common.name')} <span className="text-red-500">*</span></label>
                            <CustomInput name='fullName' placeholder={t('placeholder.name')} value={formData.fullName} handleInputChange={handleInputChange} />
                        </div>

                        <div>
                            <label>{t('common.personal-id')}<span className="text-red-500">*</span></label>
                            <div className="mt-2 relative flex items-center">
                                <input
                                    type="number"
                                    name="personalID"
                                    className={`form-control h-[40px] no-spin-buttons relative z-40 pr-12 ${!!validationMessages.personalID ? "invalid" : ""
                                        }`}
                                    value={formData.personalID}
                                    onBlur={handleBlur}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // ✅ Chỉ cho phép tối đa 12 chữ số
                                        if (value.length <= 12) {
                                            handleInputChange(e);
                                            setFormData((prev) => ({ ...prev }));
                                        }
                                    }}
                                    placeholder={t('placeholder.personal-id')}
                                />
                                <ControlpanelPrimaryButton
                                    disabled={
                                        !!validationMessages.personalID || !formData.personalID || readingCard
                                    }
                                    className={`w-[6.25rem] !absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50 ${!!validationMessages.personalID ||
                                        !formData.personalID ||
                                        formData.personalID.length !== 12
                                        ? "opacity-50"
                                        : ""
                                        }`}
                                    onMouseDown={() => (skipBlurRef.current = true)}
                                    onClick={() => handleReadCard(formData.personalID)}
                                >
                                    {readingCard ? (
                                        <CircularProgress size={18} color="inherit" />
                                    ) : (
                                        t("button.read-card")
                                    )}
                                </ControlpanelPrimaryButton>
                            </div>
                        </div>

                        <div>
                            <label>{t('common.email')} <span className="text-red-500">*</span></label>
                            <div className="mt-2 relative flex items-center h-10">
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control h-10 pr-10"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder={"name@example.com"}
                                />
                            </div>

                            {/* MESSAGE */}
                            {validationMessages.email && (
                                <p className="mt-2 text-sm text-red-500">
                                    {t(validationMessages.email)}
                                </p>
                            )}
                        </div>

                        <div className="space-y-2 col-span-2">
                            <label className="block">{t("common.phone")} <span className="text-red-500">*</span></label>
                            <div className="relative flex items-center h-10">
                                {/* <div className="flex items-center jus gap-1 ps-3.5 relative z-10">
                                    <img
                                        src={selectedPhoneCountry.nationFlag}
                                        alt="flag-icon"
                                        className="w-6"
                                    />
                                    <span className="text-black">
                                        {selectedPhoneCountry.callingCode}
                                    </span>
                                </div> */}
                                <input
                                    className={`absolute inset-0 -top-[1px] form-control h-10`}
                                    value=""
                                    onChange={() => { }}
                                />
                                <input
                                    type="number"
                                    // placeholder={selectedPhoneCountry.placeHolder}
                                    name="phone"
                                    className="no-spin-buttons relative z-10 pl-4 flex-1 h-10 outline-none px-2 border-none rounded-r-md bg-transparent item-center"
                                    onChange={handleInputChange}
                                    value={formData.phone}
                                    placeholder={"0123456789"}
                                />
                                {formData.phone && !validationMessages.phone && (
                                    <span className="absolute inset-y-[-3px] right-0 px-3 py-3">
                                        <DoneIcon fontSize="small" className="text-green-500" />
                                    </span>
                                )}
                                {!!validationMessages.phone && (
                                    <span className="absolute inset-y-[-3px] right-0 px-3 py-3">
                                        <ErrorIcon fontSize="small" className="text-red-500" />
                                    </span>
                                )}
                            </div>
                            {validationMessages.phone && (
                                <p className="text-sm text-red-500 mt-1">
                                    {t(validationMessages.phone)}
                                </p>
                            )}
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className='flex gap-2 px-4 py-4'>
                        <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                            <p>{t('button.cancel')}</p>
                        </ControlpanelSecondaryButton>

                        <ControlpanelPrimaryButton
                            onClick={handleSubmit}
                            disabled={
                                !formData.fullName ||
                                !formData.personalID ||
                                !formData.email ||
                                !formData.phone || !!validationMessages.personalID ||
                                !!validationMessages.email ||
                                !!validationMessages.phone
                            }
                        >
                            <p>{t('button.update')}</p>
                        </ControlpanelPrimaryButton>
                    </div>
                </DialogActions>
            </CustomDialog>

            <Popper
                open={openAdvanced}
                anchorEl={anchorRefAdvanced.current}
                placement="bottom-start"
                transition
                disablePortal
                className="z-[9999]"
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "left top" : "left bottom",
                        }}
                    >
                        <Paper style={{ borderRadius: "8px", }}>
                            <ClickAwayListener onClickAway={handleCloseAdvanced}>
                                <CustomAdvancedMenuList
                                    id="advanced-menu"
                                    aria-labelledby="advanced-button"
                                >
                                    <MenuItem onClick={() => {
                                        handleOpenCamera();
                                        setOpenAdvanced(false); // 👈 thêm dòng này
                                    }}>
                                        <Link>
                                            <ImportIcon16pxSvg />
                                            <p>{t("common.take-photo")}</p>
                                        </Link>
                                    </MenuItem>
                                </CustomAdvancedMenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

            {openFile && (
                <ImportDataDialog
                    onClose={() => setOpenFile(false)}
                    onConfirm={(base64) => {
                        setFormData((prev) => ({
                            ...prev,
                            faceImage: base64,
                        }));

                        setOpenFile(false);
                    }}
                />
            )}
        </>
    )
}

export default EditVisitorUserDialog